import { get} from '../../Services/http';
import { catchError } from '../../Actions/Error.action';

export const NEXT_PLANNED_DELIVERY_RECEIVE = 'NEXT_PLANNED_DELIVERY_RECEIVE';
export const NEXT_PLANNED_DELIVERY_LOADING = 'NEXT_PLANNED_DELIVERY_LOADING';
export const NEXT_PLANNED_DELIVERY_LOAD_ERROR = 'NEXT_PLANNED_DELIVERY_LOAD_ERROR';

export const loadError = error => ({
    type: NEXT_PLANNED_DELIVERY_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = nextPlannedDelivery => ({
    type: NEXT_PLANNED_DELIVERY_RECEIVE,
    payload: nextPlannedDelivery,
})

export const loadNextPlannedDelivery = () => (dispatch, getState) => {
    return get('/api/serviceOrder/nextPlannedDelivery')
        .then(response => response.json())
        .then(nextPlannedDelivery => dispatch(receive(nextPlannedDelivery)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))));
}